// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__o2ZuZ","label":"LabeledBox_label__24VyU"};